/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */
import { RemixBrowser } from "@remix-run/react";
import { StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";

import { startMonitoring } from "./lib/monitoring/monitoring";

hydrateRoot(
  document,
  <StrictMode>
    <RemixBrowser />
  </StrictMode>,
);

// Sentry sólo con DSN y en un chunk aparte, después de hidratar (ver lib/monitoring). Los
// errores de render los ataja el ErrorBoundary de root, que los reporta por `reportError`.
startMonitoring();
